// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2yxMh","header":"ReportDetails_header__T4pkW","title":"ReportDetails_title__7X6a2","left":"ReportDetails_left__2v40i"};